var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclaimer"},[_c('img',{staticClass:"disclaimer__info-icon",attrs:{"src":require("@/_shared/assets/images/icons/icons-20-info.svg")}}),_vm._v(" "+_vm._s(_vm.$t(_vm.message))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }